import React from 'react';
import { useCryptoNewsQuery } from '../../../../services/cryptoNewsAPI';
import Spinner from '../../../utils/Spinner';
import StockNewsCard from "../../StockDetails/StockNews/StockNewsCard";

const CryptoNews = ({crypto}) => {    
    const {data, isFetching} = useCryptoNewsQuery(crypto);
    const cryptoNews = data?.value;
    return (
        <div className="row py-2 ">
            {
                isFetching
                ? <Spinner />
                :  
                cryptoNews?.map((news,i) => (
                    <StockNewsCard key={i} news={news}/>
                ))
            }
        </div>
    )
}

export default CryptoNews
